import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, isRef as _isRef, withKeys as _withKeys, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47d67701"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/search.png",
  alt: "",
  class: "btn-img"
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 0,
  class: "filter-icon"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/filter_icon.png",
  alt: ""
}, null, -1))
const _hoisted_5 = { class: "filter-content" }
const _hoisted_6 = { class: "filter-item" }
const _hoisted_7 = { class: "filter-item-title" }
const _hoisted_8 = { class: "filter-item" }
const _hoisted_9 = { class: "filter-item-title" }
const _hoisted_10 = { class: "filter-btn" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/close.png",
  alt: ""
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]

import { t } from '@/plugins/i18n'
import { useSlots, ref, computed, Ref, reactive } from 'vue'
import { useStore } from 'vuex'
import { isKO, isEN } from '@/store'
interface C {
  cateNameJp: string
  productCategoryFrontendId: string | number
}

export default /*#__PURE__*/_defineComponent({
  props: ['placeholder', 'value', 'showFilter', 'loading'],
  emits: ['update:value', 'search', 'submit'],
  setup(__props, { expose, emit: emits }) {

const props = __props
const store = useStore()
const slots = useSlots()


const dropdownRef = ref()
const sellPriceDict = [
  { label: t('全部'), value: '' },
  { label: t('0-10元'), value: '0,10' },
  { label: t('10-20元'), value: '10,20' },
  { label: t('20-30元'), value: '20,30' },
  { label: t('30-50元'), value: '30,50' },
  { label: t('50-100元'), value: '50,100' },
  { label: t('100-150元'), value: '100,150' },
  { label: t('200-300元'), value: '200,300' },
  { label: t('300元以上'), value: '300,' }
]
// 搜索关键字
const keyword = computed({
  get: () => props.value,
  set: (val) => {
    emits('update:value', val)
  }
})
// 分类
const productCategoryFrontendId = ref('')
const oldProductCategoryFrontendId = ref('')
// 价格区间
const priceRange = ref('')
const oldPriceRange = ref('')
const search = () => {
  emits('search', {
    keyword: keyword.value,
    productCategoryFrontendId: productCategoryFrontendId.value,
    priceRange: priceRange.value
  })
}
const buss = reactive(store.state.bussiness)
const cates: Ref<C[]> = ref([
  {
    cateNameJp: t('全部类目'),
    productCategoryFrontendId: ''
  }
])
buss.promise.then(() => {
  cates.value = buss.category[buss.schannel || '0']
})
const getCateName = (v: any) => {
  if (isEN()) {
    return v.cateNameEn
  }
  if (isKO()) {
    return v.cateNameKr
  }
  return v.cateNameJp
}
const dropFn = (e: boolean) => {
  if (!e) {
    priceRange.value = oldPriceRange.value
    productCategoryFrontendId.value = oldProductCategoryFrontendId.value
  }
}
const submit = () => {
  oldPriceRange.value = priceRange.value
  oldProductCategoryFrontendId.value = productCategoryFrontendId.value
  dropdownRef.value.handleClose()
  if (!keyword.value && !productCategoryFrontendId.value) return
  emits('search', {
    keyword: keyword.value,
    productCategoryFrontendId: productCategoryFrontendId.value,
    priceRange: priceRange.value
  })
}
const close = () => {
  dropdownRef.value.handleClose()
}
const resetFilter = () => {
  productCategoryFrontendId.value = ''
  oldProductCategoryFrontendId.value = ''
  priceRange.value = ''
  oldPriceRange.value = ''
}
expose({
  resetFilter
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_input = _resolveComponent("el-input")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_input, {
    class: "search",
    placeholder: __props.placeholder,
    modelValue: _unref(keyword),
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(keyword) ? (keyword).value = $event : null)),
    onInput: _cache[6] || (_cache[6] = e => emits('update:value', e)),
    onKeyup: _withKeys(search, ["enter"])
  }, _createSlots({
    append: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["append-slot rel", __props.showFilter ? 'filter' : ''])
      }, [
        _withDirectives(_createElementVNode("div", {
          class: "search-btn flex-center",
          onClick: search
        }, _hoisted_2, 512), [
          [_directive_loading, __props.loading]
        ]),
        (__props.showFilter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_el_dropdown, {
                trigger: "click",
                "popper-class": "filter-dropdown",
                placement: "bottom-end",
                ref: (_value, _refs) => {
                  _refs['dropdownRef'] = _value
                  dropdownRef.value = _value
                },
                onVisibleChange: dropFn
              }, {
                dropdown: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('类目筛选')), 1),
                      _createVNode(_component_el_select, {
                        class: "select",
                        modelValue: productCategoryFrontendId.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((productCategoryFrontendId).value = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cates.value, (v) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: getCateName(v),
                              value: v.productCategoryFrontendId,
                              key: getCateName(v),
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (dropdownRef.value.handleOpen()))
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('价格筛选')), 1),
                      _createVNode(_component_el_select, {
                        class: "select",
                        modelValue: priceRange.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((priceRange).value = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sellPriceDict, (item) => {
                            return _createVNode(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value,
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (dropdownRef.value.handleOpen()))
                            }, null, 8, ["label", "value"])
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_el_button, {
                        class: "btn",
                        onClick: close
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        class: "btn",
                        onClick: submit
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('确定')), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 512)
            ]))
          : _createCommentVNode("", true),
        (_unref(keyword))
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "del abs",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (emits('update:value', '')))
            }, _hoisted_12))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 2
  }, [
    (_unref(slots).prepend)
      ? {
          name: "prepend",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "prepend")
          ])
        }
      : undefined
  ]), 1032, ["placeholder", "modelValue", "onKeyup"]))
}
}

})